import { Routes, Route } from "react-router-dom";
import AdminclientLayout from "../layouts/AdminclientLayout";
import TaskBoardWrapper from "../pages/admin-client/TaskBoardWrapper";
import TicketDetailCard from "../pages/admin-client/PageDetail";
import TicketForm from "../pages/admin-client/AddTaskForm";
import ValidationSteps from "../pages/admin-client/ValidationSteps";
import EmployeesList from "../pages/admin-client/EmployeesList";
import EmployeeDetail from "../pages/admin-client/EmployeeDetail";
import AddEmployee from "../pages/admin-client/AddEmployee";
import DemandeRefuser from "../pages/admin-client/demandeRefuser"

import Index from "../auth/Index";

const AdminclientRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<AdminclientLayout />}>
                <Route path="home" element={<TaskBoardWrapper />} />
                <Route path="/task/:id" element={< TicketDetailCard/>} />
                <Route path="task/create" element={<TicketForm />} />
                <Route path="confirmation" element={<ValidationSteps />} />
                <Route path="employees" element={<EmployeesList />} />
                <Route path="add-employee" element={<AddEmployee />} />
                <Route path="demande-refuser" element={<DemandeRefuser />} />
                      {/* idem pour le détail salarié */}
                <Route path="employees/:empId" element={<EmployeeDetail />} />
                <Route index element={<Index />} />
            </Route>
        </Routes>
    );
};

export default AdminclientRoutes;
